import delay from '../../helpers/delay';

export default class Thumbnails {

  constructor( carousel, options ) {

    if ( carousel !== undefined && typeof options === 'object' ) {

      this.t = {
        carousel              : carousel,
        thumbnailContainer    : options.thumbnailContainer,
        count                 : options.count,
        carouselName          : options.carouselName,
        slidesPerView         : options.slidesPerView,
        spaceBetween          : options.spaceBetween,
        thumbnailWidth        : 100 / options.slidesPerView,
        offsetPercent         : 0,
        offsetAmount          : 0,
        offsetMargin          : 0,
        placesOffset          : 0,
        lastThumbnailReached  : false,
        halfThumbnail         : 'right'
      }

      this.t.thumbnails = this.t.thumbnailContainer.querySelectorAll( '.thumbnail-slide' );
      this.init();

    } else {
      console.warn( 'Ensure you have properly setup your thumbnails object' );
    }
  }

  handleCarouselSlideChange() {
    let t = this.t;
    let thumbnail = {
      index : parseInt( t.carousel.activeIndex )
    }
    this.handleThumbnailSlide( thumbnail );
  }

  addThumbnailListeners() {
    let t = this.t;

    Array.prototype.forEach.call( t.thumbnails,  thumbnail => {
      thumbnail.addEventListener( 'click', this.handleThumbnailClick.bind( this ) );
    })

    window.addEventListener('resize', this.setVideoThumbnailHeight.bind(this));
  }

  slideThumbnailForward( thumbnail ) {
    let t = this.t;
    let lastThumbnailIndex = t.count - 1;
    let thumbnailWidth = t.thumbnails[0].offsetWidth;

    if( thumbnail.index === lastThumbnailIndex ) {
      if( !t.lastThumbnailReached ) {
        t.offsetAmount = t.offsetAmount + ( thumbnailWidth / 2 );
      }
      t.halfThumbnail = 'left';
    } else if ( t.halfThumbnail === 'left' ) {
      t.offsetAmount    = t.offsetAmount + ( thumbnailWidth / 2 );
      t.offsetMargin    = t.offsetMargin + (t.spaceBetween / 2);
      t.halfThumbnail   = 'right';
    } else {
      t.offsetAmount  = t.offsetAmount + thumbnailWidth;
      t.offsetMargin  = t.offsetMargin + (t.spaceBetween / 2);
    }

    if( !t.lastThumbnailReached ) {
      let offset = t.offsetAmount + t.offsetMargin;
      t.thumbnailContainer.style.transform = `translateX(-${offset}px)`
    }

    if( thumbnail.index === lastThumbnailIndex ){
      t.lastThumbnailReached = true;
    }

    if( !t.lastThumbnailReached ) {
      t.placesOffset = t.placesOffset + 1;
    }
  }

  slideThumbnailBackward( thumbnail ) {
    let t = this.t;
    let thumbnailWidth = t.thumbnails[0].offsetWidth;

    if( thumbnail.index === 0 ) {
      t.offsetAmount    = 0;
      t.offsetMargin    = 0;
      t.halfThumbnail   = 'right';
    } else if( t.halfThumbnail === 'right' ) {

      t.offsetAmount    = t.offsetAmount - (thumbnailWidth / 2);
      t.offsetMargin    = t.offsetMargin - (t.spaceBetween / 2);
      t.placesOffset    = t.placesOffset - 1;
      t.halfThumbnail   = 'left';
    } else {

      t.offsetAmount    = t.offsetAmount - thumbnailWidth;
      t.offsetMargin    = t.offsetMargin - (t.spaceBetween / 2);
      t.placesOffset    = t.placesOffset - 1;
    }

    let offset = t.offsetAmount;

    t.thumbnailContainer.style.transform = `translateX(-${offset}px)`
    t.lastThumbnailReached = false;
  }

  handleThumbnailSlide( thumbnail ) {
    let t = this.t;
    let slidesOutOfView = t.count - (t.slidesPerView) - t.placesOffset;

    if( thumbnail.index === ( t.count - slidesOutOfView )) {
      this.slideThumbnailForward( thumbnail );
    }

    if( thumbnail.index === t.placesOffset ) {
      this.slideThumbnailBackward( thumbnail );
    }
  }

  handleThumbnailClick( event ) {
    let t = this.t;
    let index = event.target.getAttribute( 'data-carousel-index');
    if(!index) {
      index = event.target.parentNode.getAttribute( 'data-carousel-index');
    }
    let thumbnail = {
      index : parseInt(index)
    };
    // Slide to new image
    t.carousel.slideTo( thumbnail.index );
    this.handleThumbnailSlide( thumbnail );
  }

  setVideoThumbnailHeight( thumbnail, thumbnails ) {
    if(thumbnail && thumbnails) {
      let sampledImage = thumbnails[0].querySelector('img');
      sampledImage && setTimeout(function(){
        let imgWidth = sampledImage.offsetWidth;
        let imgHeight = sampledImage.offsetHeight;
        thumbnail.querySelector('video').style.width = `${imgWidth}px`;
        thumbnail.querySelector('video').style.height = `${imgHeight}px`;
      }, 0)
    } else {
      let t = this.t;

      Array.prototype.forEach.call(t.thumbnails, (thumbnail) => {
        if(thumbnail.querySelector('video')) {
          this.setVideoThumbnailHeight(thumbnail, t.thumbnails);
        }
      })
    }
  }

  setThumbnailWidths() {
    let t = this.t;

    // Using this syntax for Firefox
    Array.prototype.forEach.call( t.thumbnails, ( thumbnail, i ) => {
      if( i === 0 ) {
        thumbnail.classList.add( 'thumbnail-slide-active' );
      }

      thumbnail.style.marginRight = (t.spaceBetween / 2) + 'px';

      let visibleMargins = t.slidesPerView * (t.spaceBetween / 2) + 'px';
      let visibleImages = t.slidesPerView + 0.5;

      thumbnail.style.width = 'calc((100% - ' + visibleMargins + ') / ' + visibleImages + ')';

      if( i === 0 ) {
        this.thumbnailWidthpx = thumbnail.offsetWidth;
      }

      if(thumbnail.querySelector('video')) {
        thumbnail.querySelector('video').removeAttribute('controls');
        thumbnail.querySelector('video').removeAttribute('controlslist');
        delay(300, this.setVideoThumbnailHeight(thumbnail, t.thumbnails));
      }
    })
  }

  init() {
    this.setThumbnailWidths();
    this.addThumbnailListeners();
  }
}
